import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 60,
    marginLeft : 30
  },
  reportTitle: {
    fontSize: 12,
    textAlign: "center",
    textTransform: "uppercase",
  },
 

});

const SignatureFiled = () => (
  <View style={styles.titleContainer}>
      <Text >Signature</Text>
   

  
  </View>
);

export default SignatureFiled;
